import { merge } from 'lodash-es'
import useAlert from './useAlert'
import useConfirm from './confirm/useConfirm'
import { TemplateLoaderProps } from './types'

interface Configuration
    extends Omit<TemplateLoaderProps, 'getLocale' | 'refetchViewer' | 'template' | 'templates'> {
    defaultApps: string[]
    showConfirm?: ReturnType<typeof useConfirm>
    showAlert?: ReturnType<typeof useAlert>
    envs?: Record<string, string>
}

declare global {
    interface Window {
        // @ts-ignore
        config: Configuration
    }
}

let config: Configuration = { defaultApps: [] }
export const getConfig = (): Configuration => {
    if (typeof window !== 'undefined') {
        if (!window.config) {
            //@ts-ignore
            window.config = config
        }
        //@ts-ignore
        return window.config
    }
    return config
}
export const setConfig = (conf: Partial<Configuration>): Configuration => {
    const c = getConfig()
    config = merge({}, c, conf)
    if (typeof window !== 'undefined') {
        //@ts-ignore
        window.config = config
    }
    return config
}

export default function configure(config: Partial<Configuration>): Configuration {
    return setConfig(config)
}
